import "./ClickIcon.scss";

import { ReactComponent as add } from "../../../../assets/icons/add.svg";
import { ReactComponent as addSquare } from "../../../../assets/icons/addSquare.svg";
import { ReactComponent as backarrow } from "../../../../assets/icons/backarrow.svg";
import { ReactComponent as camera } from "../../../../assets/icons/camera.svg";
import { ReactComponent as close } from "../../../../assets/icons/close.svg";
import { ReactComponent as comment } from "../../../../assets/icons/comment.svg";
import { ReactComponent as dots } from "../../../../assets/icons/dots.svg";
import { ReactComponent as downarrow } from "../../../../assets/icons/down-arrow.svg";
import { ReactComponent as edit } from "../../../../assets/icons/edit.svg";
import { ReactComponent as eye } from "../../../../assets/icons/eye.svg";
import { ReactComponent as eyeslash } from "../../../../assets/icons/eyeslash.svg";
import { ReactComponent as search } from "../../../../assets/icons/search.svg";
import { ReactComponent as send } from "../../../../assets/icons/send.svg";
import { ReactComponent as share } from "../../../../assets/icons/share.svg";

import AcedTooltip from "../../tooltip/AcedTooltip";

const icons = {
  add,
  addSquare,
  backarrow,
  camera,
  close,
  comment,
  dots,
  downarrow,
  edit,
  eye,
  eyeslash,
  search,
  send,
  share,
};

export interface ClickIconProps {
  onClick?: any;
  icon: keyof typeof icons;
  tooltip?: string;
  size?: "s" | "m" | "l" | number;
  label?: string | number;
  color?: string;
  className?: string;
}

const ClickIcon: React.FC<ClickIconProps> = ({
  onClick,
  icon,
  tooltip,
  size,
  label,
  color,
  className,
}) => {
  const Icon = icons[icon];

  if (!Icon) return null;

  const colorStyle = {
    "--icon-color": color ? color : "white",
  } as React.CSSProperties;

  const main = () => {
    return (
      <div
        onClick={onClick ? onClick : null}
        className={`icon-button ${
          onClick && "icon-button-active"
        } ${className}`}
      >
        <Icon
          style={colorStyle}
          className={`icon-icon ${onClick ? "icon-active" : "icon-inactive"}`}
        />
        {label && <div className="icon-label">{label}</div>}
      </div>
    );
  };
  return (
    <>
      {tooltip ? (
        <AcedTooltip text={tooltip}>{main()}</AcedTooltip>
      ) : (
        <>{main()}</>
      )}
    </>
  );
};

export default ClickIcon;
